import type { Media, Pagesv2 } from "@mw/shared/payload-types";
export type TechnologyPageDocument = Pagesv2 & { template: "technologies" };

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function getImageFromAsset(value: unknown): Media | string | null {
  if (!isObject(value) || !("image" in value)) {
    return null;
  }

  return (value.image as Media | string | null | undefined) ?? null;
}

export function isPagesv2TechnologyPage(value: unknown): value is Pagesv2 & { template: "technologies" } {
  return isObject(value) && value.template === "technologies";
}

export function getTechnologyPageIcon(value: unknown): Media | string | null {
  if (!isObject(value) || !isPagesv2TechnologyPage(value)) return null;
  return value.technologiesFields?.icon ?? null;
}

export function getTechnologyPageCover(value: unknown): Media | string | null {
  if (!isObject(value) || !isPagesv2TechnologyPage(value)) return null;
  return (
    getImageFromAsset(value.technologiesFields?.cardCover) ??
    getImageFromAsset(value.technologiesFields?.heroAsset) ??
    getImageFromAsset(value.meta) ??
    null
  );
}

export function getTechnologyPageFields(page: TechnologyPageDocument) {
  // Single normalized mapping: technologies live under pagesv2 template
  return {
    title: page.title,
    pageTitle: page.pageTitle,
    shortDescription: page.shortDescription,
    slug: page.slug,
    pageColor: page.pageColor,
    preFooterConfig: page.preFooterConfig,
    seoTitle: page.technologiesFields?.seoTitle,
    color: page.technologiesFields?.color,
    heroAsset: page.technologiesFields?.heroAsset,
    omniboxBlocks: page.technologiesFields?.omniboxBlocks,
    cardCover: page.technologiesFields?.cardCover,
    icon: page.technologiesFields?.icon,
    primaryLink: page.technologiesFields?.primaryLink,
    secondaryLink: page.technologiesFields?.secondaryLink,
    badge: page.technologiesFields?.badge,
    blocks: page.technologiesContent?.blocks,
    heroLayout: page.technologiesMeta?.heroLayout,
    iOSAppId: page.technologiesMeta?.iOSAppId,
  };
}
